import React, { useState } from "react";
import "./galleryimages.css";
import { Link } from "react-router-dom";

const GalleryImages = () => {
    const images = [
        { image: "galleryimg 1.png" },
        { image: "galleryimg 2.png" },
        { image: "galleryimg 3.png" },
        { image: "galleryimg 4.png" },
        { image: "galleryimg 5.png" },
        { image: "galleryimg 6.png" },
        { image: "galleryimg 3.png" },


    ];

    const [selectedImg, setSelectedImg] = useState(null);

    return (
        <>

            <div className='top-img' >
                <img src={require("../../assets/high-angle-pills-blue-background.jpg")} alt="" />
                <div className="top-content">
                    <h1>Gallery</h1>
                    <div className="top-link">
                        <div className='home-link'>  <Link to="/" >Home</Link> </div>
                        <div className='currentpage'>Gallery</div>
                    </div>

                </div>

            </div>
            <div className="gallery-container" data-aos="fade-up">
                <div className="gallery-wrapper" data-aos="fade-up">
                    {images.map((img, index) => (
                        <img
                            key={index}
                            src={require(`../../assets/${img.image}`)}
                            alt={`gallery-${index}`}
                            className="gallery-img"
                            onClick={() => setSelectedImg(require(`../../assets/${img.image}`))}
                        />
                    ))}
                </div>
            </div>

            {/* Lightbox Popup */}
            {selectedImg && (
                <div className="lightbox" onClick={() => setSelectedImg(null)}>
                    <span className="close-btn">&times;</span>
                    <img src={selectedImg} alt="zoomed-img" className="lightbox-img" />
                </div>
            )}
        </>
    );
};

export default GalleryImages;
